<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span class="blue--text text--darken-4">R</span>
        <span class="orange--text font-weight-light">SO</span>
        <span class="blue--text text--darken-4">M</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <h1 class="blue--text text--darken-4 display-1 hidden-sm-and-down">
        Rownhams <span class="orange--text">School of</span> Motoring
      </h1>
      <v-spacer></v-spacer>
      <span class="ml-5"
        ><a href="tel" style="text-decoration: none">0782 558 0910</a>
      </span>
    </v-toolbar>

    <v-content>
      <Home />
    </v-content>
  </v-app>
</template>

<script>
import Home from "./components/Home";

export default {
  name: "App",
  components: {
    Home
  },
  data() {
    return {
      //
    };
  }
};
</script>
